import { createTheme } from '@mui/material/styles';
import { green } from '@mui/material/colors';

const theme = createTheme({
  palette: {
    primary: {
      main: green[500], // This will use the standard green from MUI
      // You can also customize different shades:
      light: green[300],
      dark: green[700],
    },
  },
});

export default theme; 